<template>
<v-row justify="center">
    <v-col cols="12" sm="10" md="8">
        <div class="card" v-for="item in items" :key="item.route">
            <img class="card-icon" :src="item.img" />
            <div class="card-middle">
                <div class="card-title">{{item.title.toUpperCase()}}</div>
                <div class="card-desc">{{item.desc}}</div>
            </div>
            <v-btn @click="goto(item.route)" color="#d05927" class="card-btn btn-font" large>{{item.label}}</v-btn>
        </div>
        <div class="logout-container">
            <span class="logout" @click="logout">LOG OUT</span>
        </div>
    </v-col>
</v-row>
</template>
<script>
import axios from 'axios'
export default {
    mounted() {
        if(this.$parent.childName) this.$parent.childName  = 'MY PROFILE';
    },
    computed: { 
        items() {
            return this.$parent.items
        },
        goto() {
            return this.$parent.goto;
        }
    },
    methods: {
        async logout() {
            const res = await axios.post('/api/auth/logout');
            const url = res.data.url;
            window.location.href = url;
        }
    }
}
</script>
<style lang="scss" scoped>
.logout-container {
    margin-top: 30px;
    direction: rtl;
}
.logout {
    color: #ea7f1d;
    font-family: Poppins;
    text-decoration: underline;
    cursor: pointer;
}
.card-desc {
    font-family: $secondary-font;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1;
    letter-spacing: normal;
}
.button {
    width: 100%;
    color: white;
    font-family: $btn-font;
    margin-bottom: 30px;
}
.card {
    border: solid 1px #a5a5a5;
    background-color: #ffffff;
    padding: 20px;
    display: flex;
    align-items: center;
}
.card-middle {
    font-family: $secondary-font;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1;
    letter-spacing: normal;
    flex: 1;
}
.card-icon {
    margin-right: 30px;
    width: 48px;
    height: 48px;
    filter: invert(43%) sepia(26%) saturate(2535%) hue-rotate(343deg) brightness(90%) contrast(88%);
}
.card-title {
    font-family: $body-font-family;
    font-size: 20px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 1;
    letter-spacing: 2.67px;
    margin-bottom: 12px;
}
.card-btn {
    color: white;
    flex-basis: 20%;
    margin-left: 20px;
    font-family: $btn-font;
}

</style>
